import { useCallback } from 'react';
import { AModal, ATitle } from '../../../../components';
import { useToast } from '../../../../hooks/toast';
import { ICompany } from '../../../../shared/interfaces';
import { postRemoveImageCompany } from '../../../../http';

interface IDeleteImage {
  open: boolean;
  close: () => void;
  image_label: string | null;
  setFileLogo: React.Dispatch<React.SetStateAction<Blob | null>>;
  setHeaderLogo: React.Dispatch<React.SetStateAction<Blob | null>>;
  setCompany: React.Dispatch<React.SetStateAction<ICompany | null>>;
}
const DeleteImage: React.FC<IDeleteImage> = ({
  open,
  close,
  image_label,
  setFileLogo,
  setHeaderLogo,
  setCompany,
}) => {
  const { addToast } = useToast();

  const handleDeleteImage = useCallback(async () => {
    if (image_label)
      await postRemoveImageCompany(image_label)
        .then(() => {
          addToast({
            type: 'success',
            title: 'Sucesso',
            description: `Imagem deletada.`,
          });
          if (image_label === 'logo_image') {
            setFileLogo(null);
          } else {
            setHeaderLogo(null);
          }
          setCompany((prevState: any) => ({
            ...prevState,
            [image_label]: null,
          }));
          close();
        })
        .catch(() =>
          addToast({
            type: 'error',
            title: 'Erro',
            description: `Erro ao tentar deletar imagem.`,
          }),
        );
  }, [image_label]);

  return (
    <AModal
      open={open}
      close={close}
      title={'Deletar imagem?'}
      onOk={handleDeleteImage}
      okText={'Deletar'}
    >
      <ATitle>
        Deseja deletar{' '}
        {image_label === 'logo_image' ? 'Logomarca' : 'Logo cabeçalho'}
      </ATitle>
    </AModal>
  );
};

export default DeleteImage;
